import { focusRing, radius, surface, transition } from './tokens';

/** Maps to @layer components utilities in styles/css/forms.css */
export const inputFieldClassName = 'input-field';
export const inputPremiumClassName = 'input-premium';
export const textareaFieldClassName = 'textarea-field';
export const selectFieldClassName = 'select-field';
export const formLabelClassName = 'form-label';
export const searchInputClassName = 'ios-search-input';

const compactFieldBase = `${radius.md} ${surface.field} px-3 py-2 text-sm ${transition} ${focusRing}`;

export const selectCompactClassName = compactFieldBase;

export function inputClassWithError(hasError, extra = '') {
  const base = [
    'mt-1.5 w-full',
    radius.md,
    'border bg-white/90 px-3 py-2.5 text-sm text-secondary-900',
    'placeholder:text-secondary-400 shadow-soft',
    focusRing,
    'disabled:cursor-not-allowed disabled:opacity-60',
    '  ',
  ].join(' ');

  const state = hasError
    ? 'border-error-500 focus:border-error-500 focus:ring-error-500/30 '
    : 'border-secondary-300/70 focus:border-orange-500 focus:ring-orange-500/30 ';

  return `${base} ${state} ${extra}`.trim();
}

export const validatedInputClassName = inputClassWithError(false);

export const tableClassName = 'min-w-full divide-y divide-secondary-200/80 ';
export const tableHeadClassName =
  'bg-gradient-to-b from-secondary-50/95 to-secondary-50/70  ';
export const tableHeaderCellClassName =
  'select-none px-4 py-3 text-[0.68rem] font-semibold uppercase tracking-[0.08em] text-secondary-500 ';
export const tableBodyClassName = 'divide-y divide-secondary-100/90 ';
export const tableRowClassName =
  'group transition-[background-color,box-shadow] duration-200 hover:bg-orange-50/35  hover:shadow-[inset_3px_0_0_0_rgb(249_115_22)]';
export const tableCellClassName = 'px-4 py-3.5 text-sm text-secondary-600 ';
export const tableCellPrimaryClassName =
  'px-4 py-3.5 text-sm font-medium text-secondary-900 ';

export function tableHeaderAlignClass(align = 'left') {
  if (align === 'right') return 'text-right';
  if (align === 'center') return 'text-center';
  return 'text-left';
}
